import { Col } from '@design-system/components/grid/grid';
import { TitleRow } from '../../../promotions/view/components/FormTypography';
import { Errors } from '../../../promotions/view/components/Errors';
import { TextInput } from '../../../promotions/view/components/TextInput';
import { ExtrasFormVM } from '../viewModel/extrasForm.viewModel';
import { wrapper } from './form.css';
import { NumberInput } from '@client/new/pages/promotions/view/components/NumberInput';
import { extrasVM } from '../Extras.page';

export const ContentLegacyGuideForm = ({ register, ...p }: ExtrasFormVM) => {
  const vm = extrasVM.useValue();
  const isSaving = vm.savingSlides?.has(vm.currentId);
  return (
    <form>
      <Col data-testid="ContentLegacyGuideForm" gap="2xl" className={wrapper}>
        <TitleRow
          title="Guide"
          button={{
            children: 'Save',
            color: 'neutral',
            loading: isSaving,
            onClick: p.lazyDispatch('Submit'),
          }}
        />
        <Errors data={p.errors} />

        <NumberInput label="Content ID" {...register('contentId')} required />
        <NumberInput label="Number of slides" {...register('count')} required />
        <TextInput label="Guide name" {...register('title')} required />
      </Col>
    </form>
  );
};
